<!--
    描述：模板设置--- 模板新增页面
    时间：2020-11-21
    Created by ws
-->
<template>
	<div class="add-main">
		<el-row class="h100" :gutter="20">
			<el-col :span="16">
				<el-form :model="formObj" ref="formObj" :rules="formRules" :show-message="false" label-width="100px">
					<el-form-item label="模板名称：" prop="sname">
						<el-input v-model="formObj.sname"></el-input>
					</el-form-item>
					<el-row :gutter="20">
						<el-col :span="12">
							<el-form-item label="业务系统：" prop="applySys">
								<el-select v-model="formObj.applySys">
									<el-option
										v-for="(item, index) in ywxt"
										:key="'系统' + index"
										:value="item.value"
										:label="item.sname"
									></el-option>
								</el-select>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="应用类型：" prop="protpcolType">
								<el-select v-model="formObj.protpcolType">
									<el-option
										v-for="(item, index) in typeList"
										:key="'类型' + index"
										:value="item.value"
										:label="item.sname"
									></el-option>
								</el-select>
							</el-form-item>
						</el-col>
					</el-row>
					<el-form-item label="模板内容：" prop="textPath">
						<wang-editor v-model="formObj.textPath" ref="wangEditor" height="100%"></wang-editor>
					</el-form-item>
				</el-form>
			</el-col>
			<el-col :span="8">
				<p class="info-title">温馨提示:</p>
				<p class="info-text">1.请复制下方列表占位标签到左侧富文本框内容对应位置;</p>
				<p class="info-text">2.该模板在被业务系统调用后，会自动替换占比标签对应的字段值；</p>

				<vxe-table :data="fieldList" border resizable highlight-current-row highlight-hover-row height="520" size="small" align="center">
					<vxe-table-column field="fieldName" title="业务字段" show-overflow min-width="130"></vxe-table-column>
					<vxe-table-column field="seizeLabel" title="占位标签" min-width="180">
						<template v-slot="{ row }">
							<div class="flex">
								<span class="left">{{ row.seizeLabel }}</span>
								<div class="right">
									<el-button type="text" size="mini" @click="doCopy(row.seizeLabel)">复制</el-button>
								</div>
							</div>
						</template>
					</vxe-table-column>
				</vxe-table>
			</el-col>
		</el-row>

		<!-- 隐藏文本 -->
		<textarea class="hidden-dom" id="curLabel"></textarea>
	</div>
</template>

<script>
import { mapState } from 'vuex'
import { getDictByParentValue } from 'api/modules/dict'
import { saveTemplate, getFieldList } from 'api/modules/field_management'

export default {
	props: {
		// 当前回显信息
		currentRow: {
			type: Object,
			default: () => {
				return {}
			}
		},

		// 模式
		mode: {
			type: String,
			default: 'add'
		}
	},
	data() {
		return {
			formObj: {
				sname: '', // 模板名称
				applySys: '', // 业务系统
				protpcolType: '', // 应用类型
				textPath: '' // 模板内容
			},
			formRules: bmElementFormRules([
				{ keyName: 'sname', validatorName: 'required', tip: '' },
				{ keyName: 'applySys', validatorName: 'required', tip: '' },
				{ keyName: 'protpcolType', validatorName: 'required', tip: '' },
				{ keyName: 'textPath', validatorName: 'required', tip: '' }
			]),
			typeList: [], // 对应系统  应用类型
			fieldList: [] // 字段表数据
		}
	},
	created() {
		if (this.mode === 'edit') {
			this.formObj = Object.assign({}, this.currentRow)
		}
	},
	methods: {
		// 切换业务系统
		handleChange(value) {
			this.formObj.protpcolType = ''
			this.typeList = []

			if (value) {
				getDictByParentValue({ value: value }).then((res) => {
					if (res.operationCode === 1) {
						this.typeList = res.data

						// 编辑时触发回显
						if (this.mode === 'edit') {
							this.formObj.protpcolType = this.currentRow.protpcolType
						}
					}
				})
			}
		},

		// 根据应用类型获取 变量表数据
		getVariable() {
			this.fieldList = []
			getFieldList({
				applySys: this.formObj.applySys,
				protpcolType: this.formObj.protpcolType
			})
				.then((res) => {
					if (res.code === 0) {
						this.fieldList = res.data
					}
				})
				.catch((err) => {})
		},

		// 点击复制标签
		doCopy(value) {
			let input = document.querySelector('#curLabel')
			input.value = value
			input.select()
			document.execCommand('copy')
		},

		// 保存
		doSubmit() {
			let params = Object.assign({}, this.formObj)
			this.$refs.formObj.validate((valid) => {
				if (valid) {
					saveTemplate(params)
						.then((res) => {
							if (res.code === 0) {
								this.$message.success('保存成功！')
								this.$emit('on-save', true)
							} else {
								this.$emit('on-save', false)
							}
						})
						.catch((err) => {
							this.$emit('on-save', false)
						})
				} else {
					this.$emit('on-save', false)
					this.$message.warning('请完善必填项')
				}
			})
		}
	},
	computed: {
		...mapState('dict', {
			ywxt: (state) => state.projectDict.mbywxt // 业务系统
		})
	},
	watch: {
		// 监听业务系统变化
		'formObj.applySys': {
			handler: function(val) {
				this.handleChange(val)
			},
			deep: true
		},

		// 监听应用类型的变化
		'formObj.protpcolType': {
			handler: function(val) {
				if (val) {
					this.getVariable()
				}
			},
			deep: true
		}
	}
}
</script>

<style scoped lang="less">
.add-main {
	height: 100%;
	overflow-x: hidden;
	overflow-y: auto;

	.info-title {
		font-size: 18px;
		font-weight: 700;
	}

	.info-text {
		line-height: 28px;
		font-size: 14px;
	}

	.flex {
		justify-content: space-between;

		.left {
			flex: 1;
			text-align: left;
		}
	}

	.hidden-dom {
		position: absolute;
		right: 0;
		top: 0;
		z-index: -10;
		opacity: 0;
	}
}
</style>
